module.exports = __webpack_public_path__ + "poster9.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster9.png
// module id = 1139
// module chunks = 10